import Accordion from 'components/Accordion';
import Address from 'components/Address';
import TooltipIcon from 'components/Tooltip/TooltipIcon';
import {StampType} from 'pages/History/SendingOrders/Details/types';
import {FC} from 'react';
import {c, t} from 'ttag';
import {AddressType} from 'types/address';

type SendViaPostProps = {
    contactOrganizationName: string;
    isSelected: boolean;
    recipientAddress?: AddressType;
    recipientContactField?: string[];
    recipientContactHonorific?: string;
    senderAddress?: AddressType;
    stampType: StampType;
    staticUrl: string;
};

const SendViaPost: FC<SendViaPostProps> = ({
    contactOrganizationName,
    isSelected,
    recipientAddress,
    recipientContactField,
    recipientContactHonorific,
    senderAddress,
    stampType,
    staticUrl,
}) => {
    if (!isSelected) return null;

    return (
        <Accordion
            header={
                <div className="flex items-center gap-2">
                    <h2 className="m-0 flex items-center gap-2 p-0">
                        {t`Send by Post`}
                        <TooltipIcon
                            href="https://help.makeleaps.jp/ja/articles/4108694-郵送代行サービスとは"
                            message={t`What is Send by Post?`}
                            onClick={(e) => e.stopPropagation()}
                            size="base"
                        />
                    </h2>
                </div>
            }
            hideDividerIfLast={true}
            id="send-via-post"
            isOpenByDefault={true}
        >
            <div className="flex text-base text-black">
                <div className="max-w-md flex-1">
                    <h3>{t`Recipient`}</h3>
                    <div className=" my-2 border-l border-grey-400 pl-2">
                        {recipientAddress && (
                            <Address address={recipientAddress} />
                        )}
                        {recipientContactField &&
                            recipientContactField.map((field, index) => (
                                <div key={field}>
                                    <span>{field}</span>
                                    {index ===
                                        recipientContactField.length - 1 &&
                                    recipientContactHonorific ? (
                                        <span>{recipientContactHonorific}</span>
                                    ) : null}
                                </div>
                            ))}
                    </div>
                </div>
                <div className="flex-1 gap-2">
                    <div>
                        <h3>{t`Envelope Stamp`}</h3>
                        <div className="my-2 border-l border-grey-400 pl-2">
                            {stampType === 'nostamp' ? (
                                <p className="text-light-disabled">{t`No Stamp`}</p>
                            ) : (
                                <img
                                    alt="Stamp"
                                    height="43"
                                    src={`${staticUrl}img/${stampType}.png`}
                                    width="150"
                                />
                            )}
                        </div>
                    </div>
                    <div>
                        <h3>{c('representation').t`Sender`}</h3>
                        <div className="my-2 border-l border-grey-400 pl-2">
                            <div>{contactOrganizationName}</div>
                            {senderAddress && (
                                <Address address={senderAddress} />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </Accordion>
    );
};

export default SendViaPost;
